import React from 'react';
import { Check } from 'lucide-react';
const comparisonData = [{
  sit: 'No sabés qué producir esta semana',
  mega: 'Improvisás el lunes a la mañana',
  jean: 'Planificador semanal listo en 10 minutos'
}, {
  sit: 'No sabés qué publicar en redes',
  mega: 'Te bloqueás y no publicás nada',
  jean: '30 ideas + calendario mensual completo'
}, {
  sit: 'No sabés cuánto ganaste en el mes',
  mega: 'Mezclás plata del negocio y del hogar',
  jean: 'Registro diario + resumen mensual automático'
}, {
  sit: 'La inflación te come el margen',
  mega: 'Subís precios al azar y perdés clientas',
  jean: 'Control anti-inflación mensual con alerta'
}, {
  sit: 'Querés crecer pero no sabés cómo',
  mega: 'Cada mes empezás de cero sin dirección',
  jean: 'Roadmap de 12 meses paso a paso'
}];
const jeanFlojoIncludes = ['Visión con metas y calendario de fechas clave', 'Planificador de producción semanal', 'Calendario de contenidos para redes', '30 ideas de estados de WhatsApp', 'Registro diario de ventas y cobros', 'Resumen financiero del método de 3 sobres', 'Control anti-inflación con alertas mensuales', 'Fichas de clientas y seguimiento', 'Devocional diario y versículos de fortaleza', 'Evaluación en 7 bloques y roadmap de escalado'];
export function ComparisonTable() {
  return <section className="py-16 px-4 bg-brand-base border-t border-white/5" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="mb-10" data-id="element-46">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-47">
            <span data-id="element-48">👑</span> ¿QUÉ AGREGA EL SISTEMA PRIMEROS $100.000?
          </h2>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl shadow-md overflow-hidden mb-12 border border-white/10" data-id="element-49">
          <div className="overflow-x-auto" data-id="element-50">
            <table className="w-full text-left border-collapse" data-id="element-51">
              <thead data-id="element-52">
                <tr className="bg-brand-green text-white" data-id="element-53">
                  <th className="p-4 font-bold w-1/3 text-center" data-id="element-54">Situación</th>
                  <th className="p-4 font-bold w-1/3 text-center border-l border-white/20" data-id="element-55">
                    ❌ Solo MegaPack
                  </th>
                  <th className="p-4 font-bold w-1/3 text-center border-l border-white/20 bg-brand-green/90" data-id="element-56">
                    ✅ Con Sistema $100.000
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-57">
                {comparisonData.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white/[0.02]' : ''} data-id="element-58">
                    <td className="p-4 text-sm font-medium text-gray-200 border-b border-white/5 text-center" data-id="element-59">
                      {row.sit}
                    </td>
                    <td className="p-4 text-sm text-center text-gray-400 border-l border-b border-white/5" data-id="element-60">
                      {row.mega}
                    </td>
                    <td className="p-4 text-sm font-bold text-brand-green text-center border-l border-b border-white/5 bg-brand-green/5" data-id="element-61">
                      {row.jean}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-brand-green/30" data-id="element-62">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center justify-center gap-2" data-id="element-63">
            <Check className="text-brand-green" data-id="element-64" /> EL SISTEMA PRIMEROS $100.000
            INCLUYE:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-65">
            {jeanFlojoIncludes.map((item, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-66">
                <div className="bg-brand-green/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-67">
                  <Check size={14} className="text-brand-green" strokeWidth={3} data-id="element-68" />
                </div>
                <span className="text-sm text-gray-200 font-medium leading-relaxed" data-id="element-69">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}